<app-ice-alert type="info">
  <div heading>Abonnement krever en 4G-kompatibel enhet</div>
  <div>
    Brukes en eldre mobil?
    <br />
    Hvis ja, anbefal en oppgradering av mobil for best mulig opplevelse av ice-nettverket.
  </div>
</app-ice-alert>
<app-info-accordion testId="two-g-sunset-info-accordion-button" [iconName]="IconNames.ice_circle_wave">
  <div header>De vanligste enhetene som ikke støtter 4G-tale</div>
  <div content>
    <b>Mobiler</b>
    <ul>
      <li>iPhone 6 og eldre</li>
      <li>
        Doro 2424, Doro 6060, Doro 1370, Doro 6040, Doro 1360, Doro 1381, PhoneEasy 624, Doro 6530, Doro 6520, PhoneEasy 509,
        Doro 6030
      </li>
      <li>Nokia 105, Nokia 130 DS, Nokia 215, Nokia 216 DS, Nokia 3310 DS</li>
    </ul>
  </div>
</app-info-accordion>
